const toShortWalletAddress = (address: string): string => {
  const length = address.length;

  return length > 14
    ? `${address.slice(0, 5)}...${address.slice(-5)}`
    : address;
};

export { toShortWalletAddress };
